export const navLink = [
	{
		name: "Specialization",
		isButton: false,
	},
	{
		name: "Teams",
		isButton: false,
	},
	{
		name: "Projects",
		isButton: false,
	},
	{
		name: "Login",
		isButton: true,
	},
];
// export const HeroItem = {};

export const DivisionInfo = {
	divisionDesc:
		"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Maecenas porttitor congue massa. Fusce posuere, magna sed pulvinar  ultricies, purus lectus malesuada libero, sit amet commodo magna eros quis urna. Nunc viverra imperdiet enim. Fusce est. Vivamus a tellus.",
	division: [
		{
			key: 1,
			name: "4K BOTS",
			desc: "4K-Bots is a department in 4K-Labs that works on AI and Robotics.",
			image: "",
		},
		{
			key: 2,
			name: "4K Devs",
			desc: "4K-Devs is a department that works on mobile, desktop & web development.",
			image: "",
		},
		{
			key: 3,
			name: "4K Things",
			desc: "4K-Things is a department in 4K-Labs that works on IOT(Internet of Things).",
			image: "",
		},
	],
};
export const MessageInfo = {
	key: 1,
	title: "CEO",
	name: "Lorem",
	Link: "#",
	shortLink: "John",
	desc: "“ Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex iurenecessitatibus doloribus nisi recusandae. Impedit omnis, errorcommodi architecto nihil perspiciatis sit? Unde repellendus veroquo expedita, magnam neque? Cupiditate. “",
};
